import { useCallback, useEffect, useState } from "react";
import { PackageCheck, BellOff } from "lucide-react";
import { WhatsAppNotifyButton } from "@/components/WhatsAppNotifyButton";
import { OverduePickupPanel } from "@/components/OverduePickupPanel";
import { usePickupTemplate } from "@/hooks/usePickupTemplate";
import { api, brl, fmtDate } from "@/lib/api";

export function PickupTodayPanel() {
  const [data, setData] = useState(null);
  const { pickup_message: template } = usePickupTemplate();

  const load = useCallback(() => api.get("/admin/pickup-today").then((r) => setData(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  if (!data) return null;
  return (
    <>
    <div className="grid gap-4 lg:grid-cols-3" data-testid="pickup-today-panel">
      <div className="rounded-md bg-slate-900 p-6 text-white">
        <PackageCheck className="h-6 w-6 text-[#25D366]" />
        <p className="mt-4 text-xs font-semibold uppercase tracking-wider text-slate-400">Prontos para retirada hoje</p>
        <p className="font-mono text-4xl font-bold" data-testid="pickup-today-count">{data.ready_today_count}</p>
      </div>
      <div className="rounded-md border border-slate-200 bg-white p-6 lg:col-span-2">
        <h2 className="mb-1 flex items-center gap-2 font-display text-lg font-bold">
          <BellOff className="h-5 w-5 text-amber-500" /> Clientes ainda não avisados
          <span className="rounded-full bg-amber-100 px-2 text-xs text-amber-800" data-testid="not-notified-count">{data.not_notified.length}</span>
        </h2>
        <p className="mb-4 text-sm text-slate-500">Pedidos disponíveis para retirada sem aviso pelo WhatsApp.</p>
        {data.not_notified.length === 0 ? (
          <p className="text-sm text-slate-400" data-testid="all-notified">Todos os clientes já foram avisados.</p>
        ) : (
          <ul className="divide-y divide-slate-100" data-testid="not-notified-list">
            {data.not_notified.map((o) => (
              <li key={o.id} className="flex flex-wrap items-center justify-between gap-3 py-3" data-testid={`not-notified-${o.number}`}>
                <div>
                  <p className="font-semibold">{o.customer.name} <span className="font-mono text-xs text-slate-400">#{o.number}</span></p>
                  <p className="text-xs text-slate-500">{o.customer.phone} · {brl(o.total)} · {fmtDate(o.updated_at)}</p>
                </div>
                <WhatsAppNotifyButton order={o} template={template} onNotified={load} compact testId={`btn-notify-${o.number}`} />
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
    <OverduePickupPanel orders={data.overdue} days={data.overdue_days} onReminded={load} />
    </>
  );
}
